import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const darkModeState = atom({
  default: false,
  effects_UNSTABLE: [persistAtom],
  key: "darkModeState",
});
